import { ActionType } from "../model";
import {setErrorAlert} from "./alert";

type DST = (sellerAgreementId: number, actionId: number) => (dispatch: Function, getState: Function, api: any) => Promise<any>;
type GECD = (parentId: string, status?: string) => (dispatch: Function, getState: Function, api: any) => Promise<any>;

export const getEnvelope = (enrollmentId?: string, pageUrl?:string) => async (dispatch: Function, getState: Function, api: any) => {
	try {
		let resp = await api.get('docusign/envelope', {}, {enrollmentId, pageUrl});
		dispatch({
			type: ActionType.ALERT,
			payload: {}
		});
		return dispatch({
			type: ActionType.GET_ENVELOPE,
			payload: resp
		});
	} catch(err) {
		return dispatch({
			type: ActionType.ALERT,
			payload: err
		});
	}
};

/**
 * Get the docusign by parentId and status
 * @param parentId
 * @param [status] defaults to NOT_SIGNED
 */
export const getExistingChildDocusign: GECD = (parentId, status) => async (dispatch, _store, api) => {
    try {
        const resp = await api.get('docusign/gen1/child/invite', {}, {status, parentId});
        dispatch({payload: resp.data, type: ActionType.EXISTING_INVITE_CHILD_DOCUSIGN});
        return resp.data;
    } catch (err) {
        return dispatch(setErrorAlert(err));
    }
};

export const getSellerAgreement = (agentId: number, pageUrl: string) => async (dispatch: Function, store: Function, api: any) => {
    try {
        const path = 'docusign/seller/envelope';
        const resp = await api.get(path, {}, {agentId, pageUrl});
        dispatch({type: ActionType.SELLER_AGREEMENT, payload: resp.data});
        return resp.data;
    } catch (err) {
        return dispatch({type: ActionType.ALERT, payload: err});
    }
}

export const addBeneficiary = (payload: any) => async (dispatch: Function, getState: Function, api: any) => {
	try {
		let resp = await api.post('docusign/beneficiary', payload, {});
		dispatch({
			type: ActionType.ALERT,
			payload: { message: "Successfully Added.", statusCode: 200 }
		});
		return dispatch({
			type: ActionType.USER_DETAILS,
			payload: resp
		});
	} catch(err) {
		return dispatch({
			type: ActionType.ALERT,
			payload: err
		});
	}
}

/**
 * Set ApprovedBy Admin in SellerDocument & Mark Action Item Completed
 * @param sellerAgreementId
 * @param actionId
 */
export const sellerDocumentSetApprovedBy: DST = (sellerAgreementId, actionId) => async (dispatch, getState, api) => {
	try {
        return api.post('docusign/seller/admin-agreement-sign', {actionId, sellerAgreementId});
	} catch(err) {
        return dispatch({payload: err, type: ActionType.ALERT});
	}
}
